/**
 * "Categoria como opção da busca" — um botão a mais na barra de transações do hero, irmão de
 * Comprar/Locação/Temporada, que em vez de trocar a TRANSAÇÃO fixa uma CATEGORIA de imóvel.
 *
 * Pedido do cs2619 (04/09): "adicione ao lado do Comprar, na busca da home, a opção da categoria
 * Lançamentos". O destino é o filtro que a listagem já entende — o próprio Daniel mandou o formato:
 *   /imoveis/venda/guarapari/-/-/-?min=…&max=…&categoria=10732&dormitorios=0&banheiros=0&…
 *
 * ⚠️ GATE POR TENANT: só os codsites deste mapa ganham o botão. Os ~300 sites seguem com a barra
 * de 3 opções — mudança de um cliente não vaza para os outros (régua da casa).
 *
 * Para estender a outro tenant basta a linha no mapa: o resto (hero, busca clássica e busca por
 * IA) já é genérico.
 */

export type CategoriaBusca = {
  /** `tbl_imovel_categoria.id_Categoria` do tenant — é o `?categoria=` da listagem. */
  id: number;
  /** Rótulo do botão. Fica no código porque a categoria do CRM se chama "Lançamento" (singular). */
  rotulo: string;
};

export const BUSCA_CATEGORIA_POR_TENANT: Record<number, CategoriaBusca> = {
  // cs2619 itamarcimoveis — categoria 10732 "Lançamento" (185 imóveis publicados em 04/09).
  2619: { id: 10732, rotulo: 'Lançamentos' },
};

/** Categoria configurada como opção de busca para o tenant, ou null (o caso dos ~300 sites). */
export const categoriaBuscaDe = (siteId: unknown): CategoriaBusca | null => {
  const id = Number(siteId);
  if (!Number.isFinite(id)) return null;
  return BUSCA_CATEGORIA_POR_TENANT[id] ?? null;
};
